/* eslint-disable no-restricted-imports */
import React, {useMemo, useState} from 'react'
import {UIGameActionButton} from '../../../common/UIGameActionButton'
import {T} from '../../../common/T'
import KnightActiveLevel1 from '@static/images/knight_active_level1.svg'
import styles from './UIGameActionButtonKnightActions.module.scss'
import commonStyles from '../UIGameActionButtonContainer.module.scss'
import {UIGameActionButtonKnightPlacement} from './UIGameActionButtonKnightPlacement'
import {UIGameActionButtonKnightMove} from './UIGameActionButtonKnightMove'
import {UIGameActionButtonKnightUpgrade} from './UIGameActionButtonKnightUpgrade'
import {UIGameActionButtonKnightActivation} from './UIGameActionButtonKnightActivation'
import {useGameStore} from '../../../store/GameStoreContext'
import {TurnState} from '@colonist/game-states'
import clsx from 'clsx'
import {useCurrentStateValidator} from '../../../store/selectors/useCurrentStateValidator'

export interface UIGameActionButtonKnightActionsProps {
    className?: string
}

export const UIGameActionButtonKnightActions = ({
    className,
}: UIGameActionButtonKnightActionsProps) => {
    const myColor = useGameStore((state) => state.myColor)
    const isPaused = useGameStore((state) => state.gamePause.isPaused)
    const currentState = useGameStore((state) => state.gameState.currentState)
    const currentStateValidator = useCurrentStateValidator()
    const isInitialPlacement = currentState.turnState === TurnState.InitialPlacement
    const isNotMyTurn = !currentStateValidator.currentTurnPlayers.includes(myColor)
    const disabled = isPaused || isInitialPlacement || isNotMyTurn
    const isOpen = useGameStore((state) => state.gameActionButtons.isKnightActionExtraButtonsOpen)
    const setKnightActionExtraButtonsOpen = useGameStore((state) => state.gameActionButtons.setKnightActionExtraButtonsOpen)
    const [childButtonStates, setChildButtonStates] = useState({
        placement: false,
        activation: false,
        upgrade: false,
        move: false,
    })

    const handleButtonClick = () => {
        setKnightActionExtraButtonsOpen(!isOpen)
    }

    const hasAnyChildActionActive = useMemo(() => Object.values(childButtonStates).some((isDisabled) => !isDisabled), [childButtonStates])
    const isDisabledWithChildActions = disabled || !hasAnyChildActionActive

    const handleChildDisabledChange = (buttonType: keyof typeof childButtonStates) => (isDisabled: boolean) => {
        setChildButtonStates((prev) => ({...prev, [buttonType]: isDisabled}))
    }

    return <div className={styles.container}>
        <UIGameActionButton
            className={className}
            disabled={isDisabledWithChildActions}
            onClick={handleButtonClick}
            onClickActionIfDisabled={handleButtonClick}
            iconPath={KnightActiveLevel1}
            tooltipPosition='bottom'
            tooltipTitle={<T id='strings:game.tooltips.knight'/>}
        />
        <div className={clsx(styles.extraButtons, {
            [styles.hidden]: !isOpen,
        })}>
            <UIGameActionButtonKnightPlacement
                className={commonStyles.actionButton}
                onDisabledChange={handleChildDisabledChange('placement')}/>
            <UIGameActionButtonKnightActivation
                className={commonStyles.actionButton}
                onDisabledChange={handleChildDisabledChange('activation')}/>
            <UIGameActionButtonKnightUpgrade
                className={commonStyles.actionButton}
                onDisabledChange={handleChildDisabledChange('upgrade')}/>
            <UIGameActionButtonKnightMove
                className={commonStyles.actionButton}
                onDisabledChange={handleChildDisabledChange('move')}/>
        </div>
    </div>
}
